import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly LANGUAGE_STORAGE_KEY = 'molhy_selected_language';
  private languageSubject = new BehaviorSubject<string>(this.getStoredLanguage());
  language$ = this.languageSubject.asObservable();

  constructor() {
    // Initialize with stored language or default to 'en'
    const storedLang = this.getStoredLanguage();
    this.languageSubject.next(storedLang);
  }

  switchLanguage(lang: string) {
    // Validate language
    if (!['en', 'ta', 'bm'].includes(lang)) {
      console.warn(`Invalid language: ${lang}. Defaulting to 'en'`);
      lang = 'en';
    }
    
    // Store in localStorage
    try {
      localStorage.setItem(this.LANGUAGE_STORAGE_KEY, lang);
    } catch (error) {
      console.warn('Failed to store language preference:', error);
    }
    
    // Notify subscribers
    this.languageSubject.next(lang);
  }

  getCurrentLanguage(): string {
    return this.languageSubject.value;
  }

  private getStoredLanguage(): string {
    try {
      const stored = localStorage.getItem(this.LANGUAGE_STORAGE_KEY);
      if (stored && ['en', 'ta', 'bm'].includes(stored)) {
        return stored;
      }
    } catch (error) {
      console.warn('Failed to retrieve stored language:', error);
    }
    return 'en'; // Default language
  }
}